import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IbSubscriptionModelsPaymentsComponent } from './ib-subscription-models-payments.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgReactModule } from '@src/app/react/ng-react.module';



@NgModule({
    declarations: [
        IbSubscriptionModelsPaymentsComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        NgReactModule
    ],
    exports: [
        IbSubscriptionModelsPaymentsComponent
    ],
    providers: [
        {
            provide: 'NewMainHeaderFacade',
            useFactory: ($injector: any) => $injector.get('NewMainHeaderFacade'),
            deps: ['$injector']
        }, {
            provide: 'CommonsModalService',
            useFactory: ($injector: any) => $injector.get('CommonsModalService'),
            deps: ['$injector']
        },
        {
            provide: 'RedirectionLandingService',
            useFactory: ($injector: any) => $injector.get('RedirectionLandingService'),
            deps: ['$injector']
        },
        {
            provide: 'CommonsGenericProxy',
            useFactory: ($injector: any) => $injector.get('CommonsGenericProxy'),
            deps: ['$injector']
        }, {
            provide: 'CurrencyService',
            useFactory: ($injector: any) => $injector.get('CurrencyService'),
            deps: ['$injector']
        }
    ]
})

export class IbSubscriptionModelsPaymentsModule { }
export { IbSubscriptionModelsPaymentsComponent } from './ib-subscription-models-payments.component';

